export function isEmpty (str) {
  return str === null || str === undefined || str === ''
}

export function isNotEmpty (str) {
  return !isEmpty(str)
}

export function clone (val) {
  return JSON.parse(JSON.stringify(val))
}

export function isNullOrUndefined (val) {
  return val === null || val === undefined
}

export function getBaseURL () {
  return document.getElementsByTagName('base')[0].getAttribute('href')
}

export const callInitializers = (initializers = [], store) => { return Promise.all(initializers.map(Initializer => new Initializer({ store }))) }
